import React, { useState, useEffect } from 'react';
import { Editor } from "react-draft-wysiwyg";
import GeneralTeacherInformation from './general-teacher-information';
import TeacherCourses from './teacher-courses';
import useDraftEditor from '../../../../hooks/useDraftEditor';
import { HandleGetExlFile } from '../../../../components/crm/requests/FileRequests';
import { useTranslation } from 'react-i18next';
import { TEACHER_DETAILS_BODY_EMPTY_TEACHER_DESC, TEACHER_DETAILS_BODY_NO_TEACHER_CV, TEACHER_DETAILS_BODY_TEACHER_COURSES_LABEL, TEACHER_DETAILS_BODY_TEACHER_CV_LABEL, TEACHER_DETAILS_BODY_TEACHER_DESC_LABEL, TEACHER_DETAILS_BODY_TEACHER_INFO_LABEL } from '../../../../i18n/keyConstants';

const Accordion = ({ label, children, defaultOpen, marginTop }) => {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div
          style={{
            borderBottom: "1px solid lightgrey",
            padding: open ? "16px 0px 0px 0px" : "16px 0px 16px 0px"
          }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer"
            }}
            onClick={() => setOpen((prev) => !prev)}
          >
            <h4 style={{ margin: 0 }}>{label}</h4>
            <div style={{ display: "flex" }}>
              {open ? '⌃' : '⌄'}
            </div>
          </div>
    
          {open && (
            <div style={{ marginTop: marginTop || "16px" }}>
              {children}
            </div>
          )}
        </div>
      )
}

const LeftPanel = ({ teacher, teacherUser }) => {
    const {
        editorState,
        setEditorState,
        jsonStringToEditorState
    } = useDraftEditor();
    const { t } = useTranslation('teacherDetailsBody');
    const [pdfUrl, setPdfUrl] = useState(null);

    useEffect(() => {
        setEditorState(jsonStringToEditorState(teacher.description));

        if (teacherUser.editPermission || teacherUser.compensationTypePermission) {
            (async () => {
                const url = await HandleGetExlFile(teacher.id);
                setPdfUrl(url.data);
            })();
        }
    }, [teacher])

    return (
        <div className='details-left-panel'>
            <div className='editor-left-panel' style={{ position: "sticky", top: 197.33, paddingTop: 0, }}>
                <Accordion defaultOpen label={t(TEACHER_DETAILS_BODY_TEACHER_DESC_LABEL)} >
                <Editor className='col-6 text-center'
                    editorState={editorState}
                    readOnly={true}
                    toolbarHidden={true}
                    placeholder={t(TEACHER_DETAILS_BODY_EMPTY_TEACHER_DESC)}
                    wrapperClassName="wrapper-class-read-only"
                    editorClassName="editor-class editor-readonly"
                    toolbarClassName="toolbar-class"
                />
                {(teacherUser.editPermission || teacherUser.compensationTypePermission) ? 
                    <>
                        <h4>{t(TEACHER_DETAILS_BODY_TEACHER_CV_LABEL)}</h4>
                        {pdfUrl === "Inget CV tillgängligt" ?
                            <p>{t(TEACHER_DETAILS_BODY_NO_TEACHER_CV)}</p>
                            :
                            <a href={`${pdfUrl}`} download={pdfUrl} target="_blank" className="text-primary">CV</a>
                        }
                    </>
                    :
                    null
                }
              </Accordion>
            </div>
        </div>
    );
}

const RightPanel = ({ teacher, teacherUser, teacherCourses }) => {
    const { t } = useTranslation('teacherDetailsBody');
    return (
        <div className='details-right-panel'>
          <div style={{ position: "sticky", top: 83.75 }}>
                <Accordion label={t(TEACHER_DETAILS_BODY_TEACHER_INFO_LABEL)} defaultOpen>
                <GeneralTeacherInformation teacher={teacher} teacherUser={teacherUser}  />
              </Accordion>
                <Accordion label={t(TEACHER_DETAILS_BODY_TEACHER_COURSES_LABEL)} marginTop="0px">
                <div className="d-flex p-1" style={{paddingTop: "0px", marginTop: "0px"}} >
                  <TeacherCourses teacherId={teacher.id} teacherUser={teacherUser} teacherCourses={teacherCourses} />
                </div>
              </Accordion>
          </div>
        </div>
    )
}

export default function TeacherDetailsBody({ teacher, teacherUser, teacherCourses }) {

    return (
        <div className='course-details-body' style={{ display: "flex", justifyContent: "space-between",maxWidth: "1200px",margin: "0px auto", flexWrap: "wrap-reverse"}}>
            <LeftPanel teacher={teacher} teacherUser={teacherUser} />
            <RightPanel teacher={teacher} teacherUser={teacherUser} teacherCourses={teacherCourses} />
        </div>
    )
}
